<template lang="pug">
.v-news-page.news-page(v-if="data")
	.news-page__head.page-head(v-if="data.title")
		component.page-head__title(
				:is="data.titleLevel ? data.titleLevel : 'h1'"
				:class="data.titleStyleLevel")
			| {{data.title}}
		a.btn.btn--lg.btn-gap(v-if="data.linkAll" :href="data.linkAll.href")
			.btn-arrow.btn__icon
				.btn-arrow__track
					.btn-arrow__track-item
						v-scope
							v-svg-icon.icon-arrow(icon="btn-arrow")
					.btn-arrow__track-item
						v-scope
							v-svg-icon.icon-arrow(icon="btn-arrow")
			| {{ data?.linkAll?.text || 'back' }}
	.news-page__body(v-if="data.items" )
		v-news-card.news-page__card(v-for="(item, index) in data.items" :key="index" :data-source="item")
	.news-page__pagination(v-if="state.page")
		v-page-nav(:page="state.page" @navigate="navigate" :pagination-button="data.paginationButton")

</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null,
			state: {
				page: null,
			},
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
			this.state.page = this.data.page;
			if (window.location.pathname.indexOf('/local/') < 0) {
				window.history.replaceState(null, null, this.data.remote);
			}

			window.scrollTo({top: 0, behavior: 'smooth'});
		},

		navigate(page) {
			this.state.page.offset = page.offset;
			this.state.page.limit = page.limit;
			this.requestDataLoad({append: page.append});
		},

		requestDataLoad(dataSetOptions) {
			this.dataLoad({
				url: this.data.remote,
				delay: true,
				data: {
					page: this.state.page,
				}
			}, dataSetOptions);
		},
	}
}

</script>